import { skipToken, useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { trpc, useTRPC } from "../../../shared/api/trpc";

export type WorkObjectFieldAuditEvent = Awaited<ReturnType<typeof trpc.workObjectFields.audit.query>>[number];

export function useWorkObjectFieldAudit(fieldId: string | null) {
  const trpc = useTRPC();
  const auditQuery = useQuery(trpc.workObjectFields.audit.queryOptions(fieldId ? { fieldId } : skipToken));

  const reload = useCallback(async () => {
    if (fieldId) await auditQuery.refetch();
  }, [auditQuery.refetch, fieldId]);

  return {
    data: auditQuery.data ?? [],
    error: auditQuery.error instanceof Error ? auditQuery.error.message : auditQuery.error ? String(auditQuery.error) : null,
    isLoading: auditQuery.isPending,
    reload,
  };
}
